/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import { getForm } from '../../../../utils/reducerHalpers/formFields';
import { createReducerDotPathName } from './naming';

const getState = (state, reducerName) =>
  _.get(state, createReducerDotPathName(reducerName));

export const selectState = (state, reducerName) => getState(state, reducerName);

export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));

export const selectFieldSum = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.sum');

export const selectFieldPaymentSystem = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.paymentSystem');

export const selectSumIncludeCommission = (state, reducerName) =>
  _.get(getState(state, reducerName), 'sumIncludeCommission');

export const selectCommissionPercent = (state, reducerName) =>
  _.get(getState(state, reducerName), 'commissionPercent');

export const selectCommissionDesc = (state, reducerName) =>
  _.get(getState(state, reducerName), 'commissionDesc');

export const selectResultObject = (state, reducerName) =>
  _.get(getState(state, reducerName), 'resultObject');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/reducers/paymentForm/selectors.js